export interface FacetModalConfig<T = any> {
  backdropClass: string;
  data?: T;
  disableClose: boolean;
  hasBackdrop?: boolean;
  panelClass: string | string[];
  centered?: boolean;
  offsetX?: number;
  offsetY?: number;
  isUpdate: boolean;
  width?: string;
  themeVariables?: Record<string, string>;
}


export const DefaultFacetModalConfig: FacetModalConfig = {
  backdropClass: '',
  disableClose: false,
  hasBackdrop: true,
  panelClass: '',
  isUpdate: false,
};
